import {Observability} from '@stripe-internal/conversations-client';
import {useObservability} from '../ObservabilityProvider';
import {useClientAnalytics} from './useClientAnalytics';

export function useClientObservability(): Observability {
  const observability = useObservability();
  const analytics = useClientAnalytics();
  return {
    ...observability,
    analytics,
  };
}
